import Linkify from "linkify-react";

type Props = {
	children: any;
}

export default function InteractiveLinks({
	children
}: Props) {


	return <Linkify options={{
		format: (value, type) => {
			try
			{
				if (type == 'url')
				{
					if (value.indexOf('?') != -1)
					{
						let params = new URLSearchParams(value.split('?')[1])

						if (params.has('name'))
						{
							return params.get('name') || value
						}
					}
				}
			}
			catch (e)
			{
				console.error(e)
			}

			return value
		}
	}}>
		{children}
	</Linkify>
}